import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=e6ea11d6&scoped=true&"
import script from "./SwitchIcon.vue?vue&type=script&lang=js&"
export * from "./SwitchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ea11d6",
  null
  
)

export default component.exports